﻿﻿﻿<div class="container-tab-lists">
    <hierarchysetup-menu (rldBranchHierarchyKey)="GetBranchHierarchyKeys(defaults.country)"></hierarchysetup-menu>

    <h2>Hierarchy Setup</h2>
    <div style="display: flex; align-items: center; justify-content: space-between;">
        <mat-form-field class="search-input">
            <input placeholder="Filter"
                   matInput
                   (keyup)="filter($event)">
        </mat-form-field>
        <div style="display: flex; justify-content: flex-end;">
            <button type="button" 
                    mat-raised-button
                    class="btn button-fix button-color-fix-orange" 
                    (click)="deployFile()" 
                    [disabled]="isDeploying"
                    [matTooltip]="isDeploying ? 'Deployment in progress...' : ''">
                Generate Deployment File <mat-icon class="icon-color-fix">cloud_upload</mat-icon>
            </button>
        </div>
    </div>
        <hierarchysetup-list (rldBranchHierarchyKey)="GetBranchHierarchyKeys(defaults.country)" [alllist]="alllist" [list]="list"></hierarchysetup-list>
    </div>
